document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});